module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor_tiktok_desktop_04@2x-6784df48acbed3be14c7992d58df9073.jpg";